import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';

export type Props = {
  children: React.ReactNode;
  className?: ClassNameComponent;
};

export default function CoursePathCardBody(props: Props) {
  const { children, className } = props;
  return (
    <section
      className={twMerge('flex flex-col gap-2.5 w-full', className?.base)}
    >
      {children}
    </section>
  );
}
